/**
 * This file still exists for legacy reasons, but any new
 * functionality should be added to the imported function, not here.
 */

import { loadRecordHit as importedLoadRecordHit } from 'js/utils/loadRecordHit';

export const loadRecordHit = () => importedLoadRecordHit();

export default loadRecordHit;
